import React, { Component } from "react";
import { Link } from "react-router-dom";

import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";

export class CaseStudies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      seo: null,
      caseStudies: [],
      loading: false,
      hasMore: true,
    };
  }

  async componentDidMount() {
    const seoData = await getSEO("case studies");

    this.setState({
      seo: seoData,
    });

    this.loadCaseStudies();
  }

  // Initial Load
  loadCaseStudies = async () => {
    try {
      this.setState({ loading: true });

      const response = await fetch(
        "https://idealtechnoride.in/api/case_study",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      this.setState({
        caseStudies: data.slice(0, 6),
        hasMore: data.length >= 6,
        loading: false,
      });
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  };

  // Load More
  loadMoreCaseStudies = async () => {
  try {
    const { caseStudies } = this.state;

    if (caseStudies.length === 0) return;

    const lastId = caseStudies[caseStudies.length - 1].cs_id;

    console.log("Last ID:", lastId);

    this.setState({
      loading: true,
    });

    const formData = new FormData();
    formData.append("cs_id", lastId);

    const response = await fetch(
      "https://idealtechnoride.in/api/case_study",
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

    this.setState((prevState) => ({
      caseStudies: [...prevState.caseStudies, ...data],
      hasMore: data.length === 6,
      loading: false,
    }));
  } catch (error) {
    console.log(error);

    this.setState({
      loading: false,
    });
  }
};

  render() {
    const {
      caseStudies,
      loading,
      hasMore,
    } = this.state;

    return (
      <div>
        <SEO seo={this.state.seo} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">

              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-3 mb-0 animated slideInLeft">
                  Case Studies
                </h1>
              </div>

              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link
                        className="text-secondary"
                        to="/"
                      >
                        Home
                      </Link>
                    </li>

                    <li className="breadcrumb-item active">
                      Case Studies
                    </li>
                  </ol>
                </nav>
              </div>

            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Case Studies Start */}
        <div className="container py-5">

          <div className="row g-4">

            {caseStudies.map((item) => (
              <div
                key={item.cs_id}
                className="col-lg-4 col-md-6"
              >
                <div className="blog-item bg-light rounded overflow-hidden h-100">

                  <img
                    className="img-fluid w-100 blog_image"
                    src={
                      item.cs_banner_image ||
                      "https://via.placeholder.com/600x400"
                    }
                    alt={item.cs_title}
                  />

                  <div className="p-4">

                    <small className="text-primary">
                      {item.cs_category}
                    </small>

                    <h5 className="mt-2">
                      {item.cs_title}
                    </h5>

                    <p>
                      {item.cs_project_overview}
                    </p>

                    <Link
                      to={`/case-study/${item.cs_slug}`}
                      className="btn btn-primary btn-sm"
                    >
                      View Case Study
                    </Link>

                  </div>
                </div>
              </div>
            ))}

          </div>

          {/* View More Button */}
          {hasMore && (
            <div className="text-center mt-5">

              <button
                className="btn btn-primary px-5 py-3"
                onClick={this.loadMoreCaseStudies}
                disabled={loading}
              >
                {loading
                  ? "Loading..."
                  : "View More"}
              </button>

            </div>
          )}

        </div>
        {/* Case Studies End */}
      </div>
    );
  }
}

export default CaseStudies;